import React from 'react';
import PropTypes from 'prop-types';

import ModalComponent from 'components/ModalComponent';

const OAuthLogoutWarning = ({ closeModal, submitForm }) => {
  const handleConfirm = () => submitForm()
    .then(() => global.location.reload())
    .catch(() => closeModal());

  const buttons = [
    <button className='btn btn-primary' type='button' onClick={handleConfirm}>
      Confirm
    </button>
  ];

  return (
    <ModalComponent
      title='Are you sure?'
      buttons={buttons}
    >
      Changing OAuth providers will log out all admins,&nbsp;
      <strong>including your currently logged-in account.</strong>
      &nbsp;Upon confirming this change, you will be redirected to the sign in page, where you will need to log in with your selected setting.
    </ModalComponent>
  );
};

OAuthLogoutWarning.propTypes = {
  closeModal: PropTypes.func,
  submitForm: PropTypes.func
};

OAuthLogoutWarning.defaultProps = {
  closeModal: () => false,
  submitForm: () => false
};

export default OAuthLogoutWarning;
